import { createApi } from '@reduxjs/toolkit/query/react'

import {
  HistoricoApiResponse,
  HistoricoReservaCentralizadaResult,
  mapearRespuestaDelHistorico,
} from '../helpers/mapearHistorico'

import { baseQuery } from '@/core/api/baseQuery'

export type { HistoricoReservaCentralizadaResult } from '../helpers/mapearHistorico'

export const historicoCambioReservaCentralizadaApi = createApi({
  reducerPath: 'historicoCambioReservaCentralizadaApi',
  baseQuery,
  endpoints: (builder) => ({
    getHistoricoCambioReserva: builder.query<HistoricoReservaCentralizadaResult, string>({
      query: (codigoReserva) =>
        `/HistoricoCambioReservaCentralizadaBusiness?codigoReserva=${codigoReserva.trim()}`,
      transformResponse: (response: HistoricoApiResponse): HistoricoReservaCentralizadaResult =>
        mapearRespuestaDelHistorico(response),
      keepUnusedDataFor: 0,
    }),
  }),
})

export const {
  useGetHistoricoCambioReservaQuery,
} = historicoCambioReservaCentralizadaApi
